import React from 'react';
import styled from 'styled-components';
import { shape, arrayOf } from 'prop-types';
import blogArticleProps from 'TMPropTypes/blogArticleProps';
import Img from 'TMComponents/ImageDynamic';

import FlexWrapper from 'TMComponents/FlexWrapper';
import NavLink from 'TMComponents/NavLink';
import { BodyReg } from 'TMComponents/Typography';
import { breakpoints } from 'TMConstants';
import CategoryPill from 'TMComponents/CategoryPill';
import { themeObj } from 'TMComponents/GlobalStyle';

const calculateWidth = (i) => {
    switch (i) {
        case 0:
        case 4:
            return 'width: 24%';
        case 1:
        case 5:
            return 'width: 35%';
        default:
            return 'width: 36.5%';
    }
};

const Wrapper = styled(FlexWrapper)`
    overflow-x: scroll;
    overflow-y: hidden;
    padding: 16px 0;
    white-space: nowrap;
    @media (min-width: ${breakpoints.mobileTablet}px) {
        flex-wrap: wrap;
        white-space: normal;
    }
`;

const Card = styled(NavLink)`
    display: inline-block;
    height: 200px;
    margin-bottom: 16px;
    margin-right: 16px;
    position: relative;
    @media (min-width: ${breakpoints.mobileTablet}px) {
        ${(props) => props.width};
    }
`;

const CardImg = styled(Img)`
    border-radius: 10px;
    height: 200px;
    transition: filter 0.25s;
    width: 300px;

    ${Card}:hover & {
        filter: blur(5px);
    }
    ${Card}:focus & {
        filter: blur(5px);
    }

    @media (min-width: ${breakpoints.mobileTablet}px) {
        width: auto;
    }
`;

const Overlay = styled(FlexWrapper)`
    background-color: rgba(255, 255, 255, 0);
    border-radius: 10px;
    height: calc(100% + 4px);
    left: -2px;
    position: absolute;
    top: -2px;
    transition: background-color 0.25s;
    width: calc(100% + 4px);

    ${Card}:hover & {
        background-color: rgba(255, 255, 255, 0.8);
    }
    ${Card}:focus & {
        background-color: rgba(255, 255, 255, 0.8);
    }
    @media (max-width: ${breakpoints.mobileTablet}px) {
        background-color: rgba(255, 255, 255, 0.8);
    }
`;

const Text = styled(BodyReg)`
    margin: 0;
    max-width: 80%;
    opacity: 0;
    text-align: center;
    transition: opacity 0.25s;
    white-space: normal;
    ${Card}:hover & {
        opacity: 1;
    }

    ${Card}:focus & {
        opacity: 1;
    }
    @media (max-width: ${breakpoints.mobileTablet}px) {
        opacity: 1;
        -webkit-text-fill-color: ${themeObj.colors.black};
    }
`;

const CategoryWrapper = styled.div`
    bottom: -10px;
    position: absolute;
    right: 0;
    text-align: right;
`;

const TrendingArticleCards = ({ articles }) => (
    <Wrapper>
        {articles.map((article, idx) => (
            <Card
                key={article.id}
                width={calculateWidth(idx)}
                href={`/blog/${article.slug}`}
                aria-label={article.title}>
                <CardImg imageData={article.featuredImage} />
                <Overlay justify="center" align="center">
                    <Text variant>{article.title}</Text>
                </Overlay>
                <CategoryWrapper>
                    {article.categories.map(({ name }) => (
                        <CategoryPill key={name} name={name} />
                    ))}
                </CategoryWrapper>
            </Card>
        ))}
    </Wrapper>
);

TrendingArticleCards.propTypes = {
    articles: arrayOf(shape(blogArticleProps)).isRequired
};

export default TrendingArticleCards;
